import type { PropsWithChildren } from 'react';

import { FormField, FormHelp, Label } from '@zillow/constellation';

import YesAndNoExpansion from '../../../Widgets/YesAndNoExpansion';

type Props = {
  yesHandler: () => void;
  noHandler: () => void;
  yesActive: boolean;
  dataTest?: string;
  className?: string;
};

export default function PetsYesAndNoExpansion({ children, yesActive, ...rest }: PropsWithChildren<Props>) {
  return (
    <FormField
      label={<Label size="lg">Will tenants have pets on the property?</Label>}
      control={
        <YesAndNoExpansion yesActive={yesActive} {...rest}>
          {children}
        </YesAndNoExpansion>
      }
      description={!yesActive && <FormHelp>Pets are not allowed if you select no</FormHelp>}
    />
  );
}
